<template>
  <main>
    <base-iframe class="mx-a" height="725" :src="iframeUrl" style="max-width: 80rem" width="100%" />
  </main>
</template>

<script setup lang="ts">
const { data, error } = await useApi().internal.getStaticPage('student-discount')
if (!data.value) throw createError({ ...error.value!, fatal: true })
const { iframeUrl } = data.value
</script>
